import useYup from '../../../hooks/useYup';

export const useCandidateValidator = (withDateOfBirth = false) => {
  const { Yup } = useYup();
  const validationSchema = Yup.object().shape({
    firstname: Yup.string().required(),
    lastname: Yup.string().required(),
    email: Yup.string().email().required(),
    dateOfBirth: withDateOfBirth ? Yup.date().nullable().required() : null,
    phoneNumber: Yup.string().phoneNumber(),
  });

  return {
    validationSchema,
    isValid: (candidate) => validationSchema.isValidSync(candidate),
  };
};
